import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "alert"]

  toggle(event) {
    const settingId = event.currentTarget.dataset.settingId
    const panel = this.panelTargets.find(target => target.id === `translations_panel_${settingId}`)

    if (panel) {
      this.alertTarget.classList.toggle("d-none")
      panel.classList.toggle("d-none")
    }
  }
}
